export default __webpack_public_path__ + "static/x-logo-black-89ca0acdd8d60c2a2fa8b59263368edd.avif";